import { render, staticRenderFns } from "./CheckoutHome.vue?vue&type=template&id=15350df0"
import script from "./CheckoutHome.vue?vue&type=script&lang=ts"
export * from "./CheckoutHome.vue?vue&type=script&lang=ts"
import style0 from "./CheckoutHome.vue?vue&type=style&index=0&id=15350df0&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15350df0')) {
      api.createRecord('15350df0', component.options)
    } else {
      api.reload('15350df0', component.options)
    }
    module.hot.accept("./CheckoutHome.vue?vue&type=template&id=15350df0", function () {
      api.rerender('15350df0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "checkout/CheckoutHome.vue"
export default component.exports